import React, { useEffect, useState } from "react";

import EventNavigation from "./EventNavigation/EventNavigation";
import EventHome from "./EventHome/EventHome";
import EventAbout from "./EventAbout/EventAbout";
import EventsGallery from "./EventsGallery/EventsGallery";
import Form from "../DefaultPage/DefaultPageComponents/Form/Form";
import Footer from "../DefaultPage/DefaultPageComponents/Footer/Footer";
import './events_popup.css';

import proptechBanner from './proptech banner.png'; 

const EventPage = () => {
    const [showPopup, setShowPopup] = useState(true);

    useEffect(() => {
        // Disable page scroll when popup is visible
        if (showPopup) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';

        // Auto close after 10 seconds
        let timeoutId;
        if (showPopup) {
            timeoutId = setTimeout(() => setShowPopup(false), 10000);
        }

        return () => {
            clearTimeout(timeoutId);
            document.body.style.overflow = '';
        };
    }, [showPopup]);

    return (
        <>
            <EventNavigation />

            {showPopup && (
                <div className="events-popup-overlay" role="dialog" aria-modal="true">
                    <div className="events-popup-content">
                        <button
                            className="events-popup-close"
                            aria-label="Close popup"
                            onClick={() => setShowPopup(false)}
                        >&times;</button>

                        {/* Clickable banner: opens external site in a new tab */}
                        <a href="https://proptech-convention.com" target="_blank" rel="noreferrer noopener">
                            <img
                                src={proptechBanner}
                                alt="Announcement"
                            />
                        </a>
                    </div>
                </div>
            )}

            <EventHome />
            <EventAbout />
            {/* <EventsGallery /> */}
            <Form />
            <Footer />
        </>
    );
};

export default EventPage;